export const serviceSitePageSlug = "service-site";

export function wordPressPageRoute(path) {
    return `/${serviceSitePageSlug}/${path}`;
}